import React, { Component } from 'react';
import { CirclePicker, CustomPicker } from 'react-color';
import styles from './styles.scss';

var { Saturation, Hue, EditableInput } = require('react-color/lib/components/common');

class ColorPicker extends Component {
  handleChange = value => {
    var color = { hex: value }
    this.props.onChange(color)
  }

  render() {
    var { hex } = this.props
    return <div>
      <div className={"ba-relative ba-mg-t-1 " + styles['saturation']}>
        <Saturation
          {... this.props}
          source={'hex'}
        />
      </div>

      <div className={styles["inputColor"]}>
        <EditableInput className={{ input: 'ba-input ba-w-100 ba-mg-y-1 ba-bold ba-text-center' }} value={hex} onChange={this.props.onChange} />
      </div>

      <div className={"ba-relative " + styles['circle']}>
        <CirclePicker
          {... this.props}
          source={'hex'}
          circleSize={24}
          circleSpacing={12}
          colors={['#EF4444', '#F97316', '#FACC15', '#4ADE80', '#2DD4BF', '#3B82F6', '#6366F1', '#EC4899', '#F43F5E', '#D946EF', '#8B5CF6', '#0EA5E9', '#10B981', '#84CC16']}

        />
      </div>

      <div className={"ba-relative ba-mg-t-1 " + styles['hue']}>
        <Hue
          {... this.props}
          source={'hex'}
          direction={'horizontal' || 'vertical'} />
      </div>
    </div>;
  }
}

export default CustomPicker(ColorPicker);



// WEBPACK FOOTER //
// ./src/components/ColorPicker/index.js